/**
 * @owner @Appboy/messaging-experience
 */

import { csvImportRemoteLookupValidators } from "@schemas/remoteLookup/csvImportRemoteLookupSchema";
import type {
  CsvImportRemoteLookupId,
  CsvImportRemoteLookupItem,
  CsvImportRemoteLookupFilters,
} from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const csvImportProvider: RemoteLookupProvider<
  CsvImportRemoteLookupId,
  CsvImportRemoteLookupItem,
  CsvImportRemoteLookupFilters
> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: csvImportRemoteLookupValidators,
};
